import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 49665 49665"
    {...props}
  >
    <path
      d="M15308 1701h32656v32657c0 7483-6123 13606-13606 13606H1701V15308c0-7484 6123-13607 13607-13607z"
      style={{
        fill: "none",
        stroke: "#2b2a29",
        strokeWidth: 3401.68,
      }}
      className="stroke1"
    />
  </svg>
)
export default SvgComponent
